import React, { Component } from 'react'
import { connect } from 'react-redux'

import ProductCareModal from './ProductCareModal'
import { trackAddItemsToTrolley } from './helpers/productCareTracking'
import { clearProductCareLightBox } from '../../helpers/taggingSerializer'

class ProductCareModalContainer extends Component {
  closeModal = () => {
    const { hide } = this.props
    clearProductCareLightBox()
    return hide()
  }

  addToTrolley = () => {
    const trackingProps = {
      ...this.props
    }
    trackAddItemsToTrolley(trackingProps)
    this.closeModal()
  }

  render = () => <ProductCareModal {...this.props} addToTrolley={this.addToTrolley} closeModal={this.closeModal} />
}

const mapStateToProps = state => {
  const { productStore, trolley = {} } = state
  const {
    data: { attributes, prices, productId: hostPartNumber, warrantyProductDetails }
  } = productStore

  if (!trolley[hostPartNumber]) return {}
  const { quantity } = trolley[hostPartNumber]

  // Used to deduce which care template to use for Product Care
  const careTypeRegex = /(\b(\w*Breakdown\w*|\w*Furniture\w*|\w*Replacement\w*|\w*Accidental\w*|\w*Mobile\w*)\b)/g
  // Get first match of care type from name
  const careType = attributes?.name?.match(careTypeRegex)?.[0]?.toString()
  const getCareType = type => {
    if (type === 'Mobile') return 'mobile_care'
    if (type === 'Breakdown' || type === 'Accidental') return 'breakdown_care'
    if (type === 'EPC') return 'EPC_care'
    if (type === 'Furniture') return 'furniture_care'
    if (type === 'Replacement') return 'replacement_care'
    if (type?.includes('Jewellery' || 'jewellery')) return 'jewellery'
    if (type === 'MonthlyExcess') return 'monthly_care_excess'
    return 'monthly_care'
  }
  const type = getCareType(careType)

  return {
    productQuantity: quantity,
    hostPrice: prices && prices.attributes.now,
    hostPartNumber,
    hostProductName: attributes.name,
    warrantyItem: attributes.isWarrantyItem,
    warrantyAttr: warrantyProductDetails.attributes,
    warrantyPartNumber: warrantyProductDetails.id,
    careType: type
  }
}

export default connect(mapStateToProps)(ProductCareModalContainer)
export { ProductCareModalContainer, mapStateToProps }
